import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetGoogleReviews } from '../../hooks/useGetGoogleReviews';
import ReviewCard from './ReviewCard';
import appConfig from '../../config/appConfig';

const GoogleReviews: React.FC = () => {
    const { reviews, isLoading, error } = useGetGoogleReviews();
    const { t } = useTranslation();

    const GOOGLE_REVIEWS_URL = `https://search.google.com/local/reviews?placeid=${appConfig.features.googleReviews.placeId}`;

    if (isLoading) {
        return <div>{t('common.loading', 'Caricamento recensioni...')}</div>;
    }

    if (error) {
        return <div className="alert alert-warning">{t('reviews.loadError', 'Impossibile caricare le recensioni.')}</div>;
    }

    if (reviews.length === 0) {
        return null; // Non mostrare nulla se non ci sono recensioni
    }

    return (
        <>
            <div className="row mb-4">
                <div className="col-12 text-center">
                    <h2>{t('reviews.title', 'Dicono di noi')}</h2>
                </div>
            </div>
            <div className="row justify-content-center">
                {reviews.map((review, index) => (
                    <div key={index} className="col-lg-4 col-md-6 mb-4">
                        <ReviewCard review={review} />
                    </div>
                ))}
            </div>
            <div className="row mt-3">
                <div className="col-12 text-center">
                    <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                        {t('reviews.readAll', 'Leggi tutte le recensioni')}
                    </a>
                </div>
            </div>
        </>
    );
};

export default GoogleReviews;